var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-list',{attrs:{"type":_vm.type,"list":_vm.officeMenuList}})
}
var staticRenderFns = []

export { render, staticRenderFns }